import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const expandedRules = composition => {
  const { variantIs, aspectTypeIs, minAspectOffsetTop, positionLocationVIs } = composition.checkers;

  return [
    rule('island/expanded/spaceAbove')
      .when(variantIs('island').and(aspectTypeIs('expanded')))
      .when(minAspectOffsetTop(220))
      .set(() => ({
        aspect: {
          hasSpaceAbove: true
        }
      })),

    rule('island/expanded/forceTop')
      .when(variantIs('island').and(aspectTypeIs('expanded')))
      .when(positionLocationVIs('top'))
      .set(() => ({
        aspect: {
          hasSpaceAbove: true
        }
      })),

    rule('island/expanded/forceBottom')
      .when(variantIs('island').and(aspectTypeIs('expanded')))
      .when(positionLocationVIs('bottom'))
      .set(() => ({
        aspect: {
          hasSpaceAbove: false
        }
      })),
  ];
};
